<div>


    <div class="table-responsive ">
        <div [ngClass]="{ 
            'calsoft-list': ChartType !== '1', 
            'header-class-new': sirType 
          }">


            <div class="list-header shadow" [fxHide]="type!=1" fxLayout="row" fxLayoutAlign="space-between center"
                style="padding: 0px 7px;">
                <div fxFlex.lt-md class="list-name">
                    <span class="primary-color" fxShow.gt-sm>{{ name }}</span>
                </div>

                <mat-form-field [style.display]="searchRequired ? '' : 'none'" fxHide fxShow.md fxShow.gt-md
                    fxFlex.lt-sm="50" class="filter-input" floatPlaceholder="never" fxFlex>
                    <button [attr.guide]="'list-btn-1' + '__' + sanitizeUrl(url)" style="font-size: 24px;"
                        [ngClass]="{'overlayProduct':searchTermMainPresent}" (click)="searchFilterMain()" matSuffix
                        mat-icon-button>
                        <mat-icon>search</mat-icon>
                    </button>
                    <input [attr.guide]="'list-inp-2' + '__' + sanitizeUrl(url)" [autocomplete]="'off'"
                        [disabled]="!searchRequired" matInput #filter placeholder="Search&hellip;" />
                </mat-form-field>
                <div *ngIf="!searchRequired" fxFlex></div>

                <button [attr.guide]="'list-btn-3' + '__' + sanitizeUrl(url)" *ngIf="!refreshRequired" fxHide fxShow.md
                    fxShow.gt-md matTooltip="Refresh" mat-icon-button (click)="resetFilters()">
                    <mat-icon>refresh</mat-icon>
                </button>



                <div *ngIf="leadFilterType1!=7 && leadFilterType1!=8">
                    <button [attr.guide]="'list-btn-4' + '__' + sanitizeUrl(url)" *ngIf="leadFilterType1>=3&&filterOpen"
                        fxHide.lt-md mat-icon-button (click)="close()">
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                </div>


                <div *ngIf="leadFilterType1!=7 && leadFilterType1!=8">
                    <button [attr.guide]="'list-btn-5' + '__' + sanitizeUrl(url)" fxLayoutAlign.lt-md="end center"
                        *ngIf="leadFilterType1>=3&&!filterOpen" fxHide.lt-md mat-icon-button (click)="openNew()">
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    </button>
                </div>


                <div *ngIf="(leadFilterType1==7 || leadFilterType1==8) && disableFilter == 0 && !isGridTypeOneToSeven">

                    <button [attr.guide]="'list-btn-6' + '__' + sanitizeUrl(url)" fxLayoutAlign.lt-md="end center"
                        *ngIf="leadFilterType1>=3&&!filterOpen" fxHide.lt-md mat-icon-button (click)="openNew1()">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                </div>
                <ng-container *ngIf="displayColumnRequired!='false'">
                    <ng-container *ngIf="!displayFilerOption">
                        <button [attr.guide]="'list-btn-7' + '__' + sanitizeUrl(url)"
                            *ngIf="columns && columns.length > 0" type="button" mat-icon-button
                            [matMenuTriggerFor]="columnFilter">
                            <mat-icon>filter_list</mat-icon>
                        </button>
                    </ng-container>

                </ng-container>

                <button [attr.guide]="'list-btn-8' + '__' + sanitizeUrl(url)" *ngIf="editBusiness" mat-raised-button
                    color="primary" (click)="openBusinessEditDialog()" class="btnNew">
                    Personalize Crm
                </button>


                <ng-content select=".actions"></ng-content>

            </div>

            <mat-menu #columnFilter="matMenu" yPosition="below" xPosition="before">

                <button [attr.guide]="'list-btn-9' + '__' + sanitizeUrl(url)" class="checkbox-item mat-menu-item"
                    *ngFor="let column of columns; let i = index; trackBy: trackByFn"
                    (click)="toggleColumnVisibility(column, $event,i)" [disabled]="column.disabled">
                    <mat-checkbox [attr.guide]="'list-chk-10' + '__' + sanitizeUrl(url)" [(ngModel)]="column.visible"
                        class="checkbox" #checkbox (click)="$event.stopPropagation()" [disabled]="column.disabled">
                        {{ column.name |uppercase }}
                    </mat-checkbox>
                </button>
            </mat-menu>

            <mat-progress-bar color="accent" mode="indeterminate" *ngIf="progress"></mat-progress-bar>
            <div *ngIf="searchRequired" fxHide fxShow.lt-md class="mobile-search-area" fxLayout="column"
                fxLayoutGap="10px">
                <mat-form-field fxFlex class="filter-input" floatPlaceholder="never">
                    <input [attr.guide]="'list-inp-11' + '__' + sanitizeUrl(url)" (keydown)="blockColon($event)"
                        [autocomplete]="'off'" [formControl]="value" matInput #filter placeholder="Search&hellip;" />
                </mat-form-field>
                <div fxLayout="row" fxLayoutGap="10px">

                    <button [attr.guide]="'list-btn-12' + '__' + sanitizeUrl(url)" (click)="mobileSearch()" fxFlex
                        color="primary" mat-flat-button>
                        Search
                    </button>
                    <button [attr.guide]="'list-btn-13' + '__' + sanitizeUrl(url)" fxFlex color="accent" mat-flat-button
                        (click)="resetFiltersMobile()">
                        Refresh
                    </button>
                </div>
            </div>


            <div *ngIf="init ">


                <div *ngIf="init" fxHide fxShow.md fxShow.gt-md>

                    <div>


                        <div [ngClass]="leadFilterType1==0 ? 'default' : '' " class="list-column-filter sir-type-module"
                            [fxLayout]="leadFilterType1 > 1 ? 'row wrap' : 'row'" fxLayout.lt-md="column"
                            fxLayoutGap.lt-md="5px" fxLayoutGap.gt-md="1px" *ngIf="filterSelectObj?.length!=0"
                            fxLayoutAlign.lt-md="center center">
                            <!-- <div> -->


                            <div *ngIf="leadFilterType1==1;else elseBlock" [ngClass]="leadFilterType1==1 ? 'ovs' : '' ">

                                <ng-container *ngFor="let filter of filterSelectObj;let i=index;; trackBy: trackByFn">

                                    <ng-container>
                                        <ng-container *ngIf="filterSelectObj[i].type!='disable'">


                                            <mat-form-field fxFlex *ngIf="columns[i] &&columns[i].visible&&filter.type!='date'
                                                &&filter.type!='disable'" style="margin-left: 5px;">
                                                <mat-label>{{filter.name | uppercase }}</mat-label>


                                                <mat-select [(ngModel)]="selectedValues[i]"
                                                    (selectionChange)="filterColumnMultiSelect($event,i,filter.type)"
                                                    multiple [disableOptionCentering]="true"
                                                    *ngIf="filter.type=='multiSelect'">

                                                    <ng-container
                                                        *ngIf="filter.property =='statusName'
                                                    ||filter.name =='Status Name'||filter.name =='Life Stage' ||filter.name =='Lead Status' || filter.property == 'status' || filter.name == 'Status'">
                                                        <mat-option
                                                            *ngFor="let opt of filtereddropdownTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='stage' || filter.name =='Deal Stage' || filter.name == 'Stage' || filter.name == 'Stage Name' || filter.property == 'b.status_name' ||filter.property =='a.stage' || filter.property =='b.statusName'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredlDealStatusTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='tracker'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredTrackerTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.trackerName">
                                                            {{opt.trackerName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='priority'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredPriorityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.priorityName">
                                                            {{opt.priorityName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='warehouse'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='brands'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredBrandTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='categoryNames'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredCategoryTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='tagName'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredtagsTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>



                                                    <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredLeadSourceTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.sourceName">
                                                            {{opt.sourceName}}
                                                        </mat-option>
                                                    </ng-container>




                                                    <ng-container>
                                                        <ng-container *ngIf="filter.name =='Owner'
                                                            ||filter.property =='a.owner_id'
                                                            ||filter.property =='ownerEmail'
                                                            ||filter.name == 'User Name'
                                                            ||filter.name == 'Created By'
                                                            ||filter.property == 'createdBy'
                                                            ||filter.property == 'created_by'
                                                            ||filter.property == 'a.created_by'
                                                            ||filter.property == 'a.user_name'">
                                                            <mat-option
                                                                *ngFor="let opt of filtereduserTypeList; let i=index;; trackBy: trackByFn"
                                                                [value]="opt.email">
                                                                {{opt.email}}
                                                            </mat-option>
                                                        </ng-container>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.name =='Type of Service'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredPayemntTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.name =='Activity Type'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredActivityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.activityType">
                                                            {{opt.activityType}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='industryType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredindustryTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='businessType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredBusinessTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='supplier' || filter.name == 'Suppliers'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredsupplierTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property !='statusName'|| filter.name !='Life Stage' || filter.name !='Owner' || filter.property !='sourceName'|| filter.name !='Activity Type' || filter.property !='ownerEmail' ||  filter.name !='tracker' ||  filter.name !='priority'">
                                                        <mat-option [disabled]="item.value=='disabled1'"
                                                            *ngFor="let item of filter.options; trackBy: trackByFn"
                                                            [value]="item.value">
                                                            {{item.viewValue}}
                                                        </mat-option>
                                                    </ng-container>
                                                </mat-select>

                                                <mat-select [disableOptionCentering]="true" [(value)]="this[filter['position']]   == undefined ? 'ALL'
                               : this[filter['position']]" (selectionChange)="filterColumn($event,i,filter.type)"
                                                    *ngIf="filter.type=='select'">

                                                    <ng-container *ngIf="(!filter.options || filter.options.length == 0) && (filter.property =='statusName'
                                                    ||filter.name =='Status Name'
                                                    ||filter.name =='Life Stage'
                                                     ||filter.name =='status'
                                                     ||filter.name =='Lead Status'
                                                     ||filter.property == 'status'
                                                     ||filter.name == 'Status')
                                                    ">
                                                        <ng-container
                                                            *ngIf="filter.name == 'Status' && name == 'Tasks'">
                                                            <mat-option
                                                                *ngFor="let opt of filteredTaskStatusTypeList; let i=index;; trackBy: trackByFn"
                                                                [value]="opt.statusName">
                                                                {{opt.statusName}}
                                                            </mat-option>
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="filter.name != 'Status' || name != 'Tasks'">
                                                            <mat-option
                                                                *ngFor="let opt of filtereddropdownTypeList; let i=index;; trackBy: trackByFn"
                                                                [value]="opt.statusName">
                                                                {{opt.statusName}}
                                                            </mat-option>
                                                        </ng-container>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='tracker'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredTrackerTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.trackerId">
                                                            {{opt.trackerName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='priority'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredPriorityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.priorityId">
                                                            {{opt.priorityName}}
                                                        </mat-option>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.property =='tagName'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredtagsTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredLeadSourceTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.sourceName">
                                                            {{opt.sourceName}}
                                                        </mat-option>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.property =='industryType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredindustryTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='businessType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredBusinessTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='supplier' || filter.name == 'Suppliers'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredsupplierTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='ownerEmail'||filter.name =='Owner'||filter.name == 'User Name'||filter.name == 'Created By' || filter.property == 'createdBy' || filter.property == 'created_by' || filter.property == 'a.created_by' || filter.property == 'a.user_name' || filter.property == 'a.owner_id'">
                                                        <mat-option
                                                            *ngFor="let opt of filtereduserTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.email">
                                                            {{opt.email}}
                                                        </mat-option>
                                                    </ng-container>




                                                    <ng-container *ngIf="filter.name =='Activity Type'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredActivityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.activityType">
                                                            {{opt.activityType}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.options && filter.options.length > 0">
                                                        <mat-option [disabled]="item.value=='disabled1'"
                                                            *ngFor="let item of filter.options; trackBy: trackByFn"
                                                            [value]="item.value">
                                                            {{item.viewValue || item.value}}
                                                        </mat-option>
                                                    </ng-container>
                                                </mat-select>
                                                <input [attr.guide]="'list-inp-14' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText trim="blur"
                                                    (keyup)="filterColumnText($event,i,filter.modelValue)"
                                                    *ngIf="filter.type != 'multiSelect' && filter.type != 'select' && filter.type != 'time' && filter.type != 'id' && filter.type != 'price'"
                                                    matInput (keydown)="blockColon($event)"
                                                    [(ngModel)]="filter.modelValue" />

                                                <input [attr.guide]="'list-inp-15' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText trim="blur"
                                                    (change)="filterColumnText($event,i,filter.modelValue)"
                                                    (keyup)="filterColumnText($event,i,filter.modelValue)" type="time"
                                                    *ngIf="filter.type=='time' " matInput (keydown)="blockColon($event)"
                                                    [(ngModel)]="filter.modelValue" />

                                                <input [attr.guide]="'list-inp-16' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText trim="blur"
                                                    numbersOnly (keyup)="filterColumnText($event,i,filter.modelValue)"
                                                    *ngIf="filter.type=='id'" (keydown)="blockColon($event)" matInput
                                                    [(ngModel)]="filter.modelValue" />

                                                <input [attr.guide]="'list-inp-17' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText
                                                    (keyup)="filterColumnText($event,i,filter.modelValue)" numbersOnly
                                                    *ngIf="filter.type=='price' " matInput
                                                    (keydown)="blockColon($event)" [(ngModel)]="filter.modelValue" />
                                            </mat-form-field>


                                            <mat-form-field fxFlex [formGroup]="filtersForm"
                                                *ngIf=" columns[i] && columns[i].visible&&filter.type=='date'&&filter.type=='date'&&filter.type!='disable'"
                                                style="margin-left: 5px;width: 100%;">
                                                <mat-label>{{filter.name | uppercase }}</mat-label>
                                                <mat-date-range-input
                                                    [formGroup]="filtersForm.get('ranges')['controls'][i]"
                                                    [rangePicker]="picker">
                                                    <input [attr.guide]="'list-inp-start' + '__' + sanitizeUrl(url)"
                                                        style="width: 100%;" disabled [autocomplete]="'off'" disabled
                                                        (dateChange)="start($event,'start',i)" matStartDate
                                                        formControlName="start" placeholder="Start date" />
                                                    <input [attr.guide]="'list-inp-end' + '__' + sanitizeUrl(url)"
                                                        style="width: 100%;" [autocomplete]="'off'" disabled
                                                        (dateChange)="end($event,'end',i)" matEndDate
                                                        formControlName="end" placeholder="End date" />
                                                </mat-date-range-input>
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-date-range-picker color="accent" disabled="false" Customer
                                                    Information #picker></mat-date-range-picker>

                                            </mat-form-field>









                                        </ng-container>
                                    </ng-container>



                                </ng-container>

                            </div>


                            <ng-template #elseBlock>


                                <ng-container *ngFor="let filter of filterSelectObj;let i=index;; trackBy: trackByFn">

                                    <ng-container>
                                        <ng-container *ngIf="filterSelectObj[i].type!='disable'">


                                            <mat-form-field fxFlex
                                                *ngIf="columns[i] &&columns[i].visible&&filter.type!='date'&&filter.type!='disable'"
                                                style="margin-left: 5px;">
                                                <mat-label>{{filter.name | uppercase }}</mat-label>




                                                <mat-select [(ngModel)]="selectedValues[i]"
                                                    (selectionChange)="filterColumnMultiSelect($event,i,filter.type)"
                                                    multiple [disableOptionCentering]="true"
                                                    *ngIf="filter.type=='multiSelect'">

                                                    <ng-container
                                                        *ngIf="filter.property =='stage' || filter.name =='Deal Stage' || filter.name == 'Stage' || filter.name == 'Stage Name' || filter.property == 'b.status_name' ||filter.property =='a.stage' || filter.property =='b.statusName'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredlDealStatusTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='statusName'
                                                    ||filter.name =='Status Name'||filter.name =='Life Stage' ||filter.name =='Lead Status' || filter.property == 'status' || filter.name == 'Status'">
                                                        <mat-option
                                                            *ngFor="let opt of filtereddropdownTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='tracker'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredTrackerTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.trackerName">
                                                            {{opt.trackerName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='priority'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredPriorityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.priorityName">
                                                            {{opt.priorityName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='warehouse'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='brands'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredBrandTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='categoryNames'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredCategoryTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='tagName'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredtagsTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredLeadSourceTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.sourceName">
                                                            {{opt.sourceName}}
                                                        </mat-option>
                                                    </ng-container>




                                                    <ng-container *ngIf="filter.name =='Owner'
                                                          || filter.property =='a.owner_id'
                                                        ||filter.property =='ownerEmail'
                                                        ||filter.name == 'User Name'
                                                        ||filter.name == 'Created By'
                                                        ||filter.property == 'createdBy'
                                                        ||filter.property == 'created_by'
                                                        ||filter.property == 'a.created_by'
                                                        ||filter.property == 'a.user_name'">
                                                        <mat-option
                                                            *ngFor="let opt of filtereduserTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.email">
                                                            {{opt.email}}
                                                        </mat-option>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.name =='Type of Service'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredPayemntTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">
                                                            {{opt.name}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='industryType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredindustryTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusId">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='businessType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredBusinessTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusId">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='supplier' || filter.name == 'Suppliers'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredsupplierTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.name =='Activity Type'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredActivityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.activityType">
                                                            {{opt.activityType}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.options && filter.options.length > 0">
                                                        <mat-option [disabled]="item.value=='disabled1'"
                                                            *ngFor="let item of filter.options; trackBy: trackByFn"
                                                            [value]="item.value">
                                                            {{item.viewValue || item.value}}
                                                        </mat-option>
                                                    </ng-container>
                                                </mat-select>

                                                <mat-select [disableOptionCentering]="true" [(value)]="this[filter['position']]   == undefined ? 'ALL'
                               : this[filter['position']]" (selectionChange)="filterColumn($event,i,filter.type)"
                                                    *ngIf="filter.type=='select'">
                                                    <mat-option value="ALL">(ALL)</mat-option>
                                                    <ng-container *ngIf="(!filter.options || filter.options.length == 0) && (filter.property =='statusName'
                                                    ||filter.name =='Status Name'
                                                    ||filter.name =='Life Stage'
                                                    ||filter.name =='Lead Status'
                                                    ||filter.property == 'status'
                                                    ||filter.name == 'Status')
                                                    ">
                                                        <ng-container
                                                            *ngIf="filter.name == 'Status' && name == 'Tasks'">
                                                            <mat-option
                                                                *ngFor="let opt of filteredTaskStatusTypeList; let i=index;; trackBy: trackByFn"
                                                                [value]="opt.statusName">
                                                                {{opt.statusName}}
                                                            </mat-option>
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="filter.name != 'Status' || name != 'Tasks'">
                                                            <mat-option
                                                                *ngFor="let opt of filtereddropdownTypeList; let i=index;; trackBy: trackByFn"
                                                                [value]="opt.statusName">
                                                                {{opt.statusName}}
                                                            </mat-option>
                                                        </ng-container>
                                                    </ng-container>



                                                    <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredLeadSourceTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.sourceName">
                                                            {{opt.sourceName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='tracker'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredTrackerTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.trackerName">
                                                            {{opt.trackerName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='priority'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredPriorityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.priorityName">
                                                            {{opt.priorityName}}
                                                        </mat-option>
                                                    </ng-container>



                                                    <ng-container
                                                        *ngIf="filter.property =='ownerEmail'||filter.name =='Owner'||filter.name == 'User Name'||filter.name == 'Created By' || filter.property == 'createdBy' || filter.property == 'created_by' || filter.property == 'a.created_by' || filter.property == 'a.user_name' || filter.property == 'a.owner_id'">
                                                        <mat-option
                                                            *ngFor="let opt of filtereduserTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.email">
                                                            {{opt.email}}
                                                        </mat-option>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.property =='tagName'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredtagsTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">
                                                            {{opt.statusName}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='industryType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredindustryTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.property =='businessType'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredBusinessTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.statusName">{{opt.statusName}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="filter.property =='supplier' || filter.name == 'Suppliers'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredsupplierTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.name">{{opt.name}}</mat-option>
                                                    </ng-container>


                                                    <ng-container *ngIf="filter.name =='Activity Type'">
                                                        <mat-option
                                                            *ngFor="let opt of filteredActivityTypeList; let i=index;; trackBy: trackByFn"
                                                            [value]="opt.activityType">
                                                            {{opt.activityType}}
                                                        </mat-option>
                                                    </ng-container>

                                                    <ng-container *ngIf="filter.options && filter.options.length > 0">
                                                        <mat-option [disabled]="item.value=='disabled1'"
                                                            *ngFor="let item of filter.options; trackBy: trackByFn"
                                                            [value]="item.value">
                                                            {{item.viewValue || item.value}}
                                                        </mat-option>
                                                    </ng-container>
                                                </mat-select>

                                                <input [attr.guide]="'list-inp-18' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText trim="blur"
                                                    (keyup)="filterColumnText($event,i,filter.modelValue)"
                                                    *ngIf="filter.type != 'multiSelect' && filter.type != 'select' && filter.type != 'time' && filter.type != 'id' && filter.type != 'price'"
                                                    matInput (keydown)="blockColon($event)"
                                                    [(ngModel)]="filter.modelValue" />

                                                <input [attr.guide]="'list-inp-19' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText trim="blur"
                                                    (change)="filterColumnText($event,i,filter.modelValue)"
                                                    (keyup)="filterColumnText($event,i,filter.modelValue)" type="time"
                                                    *ngIf="filter.type=='time' " matInput (keydown)="blockColon($event)"
                                                    [(ngModel)]="filter.modelValue" />

                                                <input [attr.guide]="'list-inp-20' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText trim="blur"
                                                    numbersOnly (keyup)="filterColumnText($event,i,filter.modelValue)"
                                                    (keydown)="blockColon($event)" *ngIf="filter.type=='id' " matInput
                                                    [(ngModel)]="filter.modelValue" />

                                                <input [attr.guide]="'list-inp-21' + '__' + sanitizeUrl(url)"
                                                    style="width: 100%;" [autocomplete]="'off'" #myText
                                                    (keydown)="blockColon($event)"
                                                    (keyup)="filterColumnText($event,i,filter.modelValue)" numbersOnly
                                                    *ngIf="filter.type=='price' " matInput
                                                    [(ngModel)]="filter.modelValue" />
                                            </mat-form-field>


                                            <mat-form-field fxFlex [formGroup]="filtersForm"
                                                *ngIf=" columns[i] && columns[i].visible&&filter.type=='date'&&filter.type=='date'&&filter.type!='disable'"
                                                style="margin-left: 5px;width: 100%;">
                                                <mat-label>{{filter.name | uppercase }}</mat-label>
                                                <mat-date-range-input
                                                    [formGroup]="filtersForm.get('ranges')['controls'][i]"
                                                    [rangePicker]="picker">
                                                    <input [attr.guide]="'list-inp-start' + '__' + sanitizeUrl(url)"
                                                        style="width: 100%;" disabled [autocomplete]="'off'" disabled
                                                        (dateChange)="start($event,'start',i)" matStartDate
                                                        formControlName="start" placeholder="Start date" />
                                                    <input [attr.guide]="'list-inp-end' + '__' + sanitizeUrl(url)"
                                                        style="width: 100%;" [autocomplete]="'off'" disabled
                                                        (dateChange)="end($event,'end',i)" matEndDate
                                                        formControlName="end" placeholder="End date" />
                                                </mat-date-range-input>
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-date-range-picker color="accent" disabled="false" Customer
                                                    Information #picker></mat-date-range-picker>

                                            </mat-form-field>










                                        </ng-container>
                                    </ng-container>



                                </ng-container>



                            </ng-template>


                            &nbsp;

                            <button [attr.guide]="'list-btn-22' + '__' + sanitizeUrl(url)"
                                *ngIf="filterOpen|| leadFilterType1 == 7" fxHide.lt-md
                                [disabled]="searchTerm==undefined && ChartType !== '1'" matTooltip="Reset Filter"
                                mat-icon-button color="warn" (click)="resetFilters()">
                                <mat-icon>autorenew</mat-icon>
                            </button>

                            <button [attr.guide]="'list-btn-23' + '__' + sanitizeUrl(url)"
                                *ngIf="filterOpen || leadFilterType1 == 7" fxHide.lt-md [disabled]="searchTermPresent"
                                matTooltip="search" mat-icon-button (click)="searchFilter()">
                                <mat-icon>search</mat-icon>
                            </button>



                        </div>
                    </div>
                </div>


            </div>
            <mat-accordion fxHide fxShow.lt-md *ngIf="filterSelectObj?.length!=0">
                <mat-expansion-panel style="border-radius: 0px;" class="br0 mat-elevation-z0">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Filters
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="list-column-filter" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="5px"
                        *ngIf="filterSelectObj?.length!=0" fxLayoutAlign.lt-md="center none">
                        <!-- <div> -->

                        <ng-container *ngFor="let filter of filterSelectObj;let i=index;; trackBy: trackByFn">
                            <ng-container *ngIf="filter.type!='disable'">
                                <mat-form-field fxFlex
                                    *ngIf="columns[i] &&columns[i].visible&&filter.type!='date'&&filter.type!='disable'"
                                    style="margin-left: 5px;">
                                    <mat-label>{{filter.name | uppercase }}</mat-label>


                                    <mat-select [(ngModel)]="selectedValues[i]"
                                        (selectionChange)="filterColumnMultiSelect($event,i,filter.type)" multiple
                                        [disableOptionCentering]="true" *ngIf="filter.type=='multiSelect'">

                                        <ng-container
                                            *ngIf="filter.property =='stage' || filter.name =='Deal Stage' || filter.name == 'Stage' || filter.name == 'Stage Name' || filter.property == 'b.status_name' ||filter.property =='a.stage' || filter.property =='b.statusName'">
                                            <mat-option
                                                *ngFor="let opt of filteredlDealStatusTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.statusName">
                                                {{opt.statusName}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="filter.property =='statusName'
                                    ||filter.name =='Status Name'||filter.name =='Life Stage' || filter.name =='Lead Status' || filter.property == 'status' || filter.name == 'Status'">
                                            <ng-container *ngIf="filter.name == 'Status' && name == 'Tasks'">
                                                <mat-option
                                                    *ngFor="let opt of filteredTaskStatusTypeList; let i=index;; trackBy: trackByFn"
                                                    [value]="opt.statusName">
                                                    {{opt.statusName}}
                                                </mat-option>
                                            </ng-container>
                                            <ng-container *ngIf="filter.name != 'Status' || name != 'Tasks'">
                                                <mat-option
                                                    *ngFor="let opt of filtereddropdownTypeList; let i=index;; trackBy: trackByFn"
                                                    [value]="opt.statusName">
                                                    {{opt.statusName}}
                                                </mat-option>
                                            </ng-container>
                                        </ng-container>


                                        <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                            <mat-option
                                                *ngFor="let opt of filteredLeadSourceTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.sourceName">
                                                {{opt.sourceName}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container *ngIf="filter.property =='tracker'">
                                            <mat-option
                                                *ngFor="let opt of filteredTrackerTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.trackerName">
                                                {{opt.trackerName}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container *ngIf="filter.property =='priority'">
                                            <mat-option
                                                *ngFor="let opt of filteredPriorityTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.priorityName">
                                                {{opt.priorityName}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container *ngIf="filter.property =='warehouse'">
                                            <mat-option
                                                *ngFor="let opt of filteredWarehouseTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container *ngIf="filter.property =='brands'">
                                            <mat-option
                                                *ngFor="let opt of filteredBrandTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container *ngIf="filter.property =='categoryNames'">
                                            <mat-option
                                                *ngFor="let opt of filteredCategoryTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </ng-container>


                                        <ng-container *ngIf="filter.property =='tagName'">
                                            <mat-option
                                                *ngFor="let opt of filteredtagsTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.statusName">
                                                {{opt.statusName}}
                                            </mat-option>
                                        </ng-container>


                                        <ng-container
                                            *ngIf="filter.name =='Owner'||filter.property =='ownerEmail'||filter.name == 'User Name'||filter.name == 'Created By' || filter.property == 'createdBy' || filter.property == 'created_by' || filter.property == 'a.created_by' || filter.property == 'a.user_name' || filter.property == 'a.owner_id'">
                                            <mat-option
                                                *ngFor="let opt of filtereduserTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.email">
                                                {{opt.email}}
                                            </mat-option>
                                        </ng-container>


                                        <ng-container *ngIf="filter.name =='Type of Service'">
                                            <mat-option
                                                *ngFor="let opt of filteredPayemntTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.name">
                                                {{opt.name}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container *ngIf="filter.name =='Activity Type'">
                                            <mat-option
                                                *ngFor="let opt of filteredActivityTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.activityType">
                                                {{opt.activityType}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="filter.property !='statusName'|| filter.name !='Life Stage' || filter.name !='Owner' || filter.property !='sourceName'|| filter.name !='Activity Type' || filter.property !='ownerEmail' ||  filter.name !='tracker' ||  filter.name !='priority'">
                                            <mat-option [disabled]="item.value=='disabled1'"
                                                *ngFor="let item of filter.options; trackBy: trackByFn"
                                                [value]="item.value">
                                                {{item.viewValue}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>

                                    <mat-select [disableOptionCentering]="true" [(value)]="this[filter['position']]   == undefined ? 'ALL'
               : this[filter['position']]" (selectionChange)="filterColumn($event,i,filter.type)"
                                        *ngIf="filter.type=='select'">
                                        <mat-option value="ALL">(ALL)</mat-option>
                                        <ng-container *ngIf="filter.property =='statusName'
                                    ||filter.name =='Status Name'
                                    ||filter.name =='Life Stage'
                                    ||filter.name =='Lead Status'
                                    ||filter.property == 'status'
                                    ||filter.name == 'Status'
                                    ">
                                            <ng-container *ngIf="filter.name == 'Status' && name == 'Tasks'">
                                                <mat-option
                                                    *ngFor="let opt of filteredTaskStatusTypeList; let i=index;; trackBy: trackByFn"
                                                    [value]="opt.statusName">
                                                    {{opt.statusName}}
                                                </mat-option>
                                            </ng-container>
                                            <ng-container *ngIf="filter.name != 'Status' || name != 'Tasks'">
                                                <mat-option
                                                    *ngFor="let opt of filtereddropdownTypeList; let i=index;; trackBy: trackByFn"
                                                    [value]="opt.statusName">
                                                    {{opt.statusName}}
                                                </mat-option>
                                            </ng-container>
                                        </ng-container>



                                        <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                            <mat-option
                                                *ngFor="let opt of filteredLeadSourceTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.sourceName">
                                                {{opt.sourceName}}
                                            </mat-option>
                                        </ng-container>



                                        <ng-container
                                            *ngIf="filter.property =='ownerEmail'||filter.name =='Owner'||filter.name == 'User Name'||filter.name == 'Created By' || filter.property == 'createdBy' || filter.property == 'created_by' || filter.property == 'a.created_by' || filter.property == 'a.user_name' || filter.property == 'a.owner_id'">
                                            <mat-option
                                                *ngFor="let opt of filtereduserTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.email">
                                                {{opt.email}}
                                            </mat-option>
                                        </ng-container>




                                        <ng-container *ngIf="filter.name =='Activity Type'">
                                            <mat-option
                                                *ngFor="let opt of filteredActivityTypeList; let i=index;; trackBy: trackByFn"
                                                [value]="opt.activityType">
                                                {{opt.activityType}}
                                            </mat-option>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="filter.name !='Status Name' || filter.name !='Life Stage' || filter.name !='Source Name' || filter.name !='Activity Type' || filter.name !='Owner' ||  filter.name !='tracker' ||  filter.name !='priority'">
                                            <mat-option [disabled]="item.value=='disabled1'"
                                                *ngFor="let item of filter.options; trackBy: trackByFn"
                                                [value]="item.value">
                                                {{item.viewValue}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>

                                    <input [attr.guide]="'list-inp-24' + '__' + sanitizeUrl(url)" style="width: 100%;"
                                        [autocomplete]="'off'" #myText trim="blur"
                                        (keyup)="filterColumnText($event,i,filter.modelValue)"
                                        (keydown)="blockColon($event)"
                                        *ngIf="filter.type != 'multiSelect' && filter.type != 'select' && filter.type != 'time' && filter.type != 'id' && filter.type != 'price'"
                                        matInput [(ngModel)]="filter.modelValue" />

                                    <input [attr.guide]="'list-inp-25' + '__' + sanitizeUrl(url)" style="width: 100%;"
                                        [autocomplete]="'off'" #myText trim="blur"
                                        (keyup)="filterColumnText($event,i,filter.modelValue)" type="time"
                                        *ngIf="filter.type=='time' " matInput (keydown)="blockColon($event)"
                                        [(ngModel)]="filter.modelValue" />

                                    <input [attr.guide]="'list-inp-26' + '__' + sanitizeUrl(url)" style="width: 100%;"
                                        [autocomplete]="'off'" #myText trim="blur" numbersOnly
                                        (keyup)="filterColumnText($event,i,filter.modelValue)"
                                        (keydown)="blockColon($event)" *ngIf="filter.type=='id' " matInput
                                        [(ngModel)]="filter.modelValue" />

                                    <input [attr.guide]="'list-inp-27' + '__' + sanitizeUrl(url)" style="width: 100%;"
                                        [autocomplete]="'off'" #myText (keydown)="blockColon($event)"
                                        (keyup)="filterColumnText($event,i,filter.modelValue)" numbersOnly
                                        *ngIf="filter.type=='price' " matInput [(ngModel)]="filter.modelValue" />
                                </mat-form-field>

                                <mat-form-field fxFlex [formGroup]="filtersForm"
                                    *ngIf="columns[i] &&columns[i].visible&&filter.type=='date'&&filter.type!='disable'"
                                    style="margin-left: 5px;">
                                    <mat-label>{{filter.name | uppercase }}</mat-label>
                                    <mat-date-range-input [formGroup]="filtersForm.get('ranges')['controls'][i]"
                                        [rangePicker]="picker">
                                        <input [attr.guide]="'list-inp-start' + '__' + sanitizeUrl(url)"
                                            [autocomplete]="'off'" readOnly (dateChange)="start($event,'start',i)"
                                            matStartDate formControlName="start" placeholder="Start date" />
                                        <input [attr.guide]="'list-inp-end' + '__' + sanitizeUrl(url)"
                                            [autocomplete]="'off'" readOnly (dateChange)="end($event,'end',i)"
                                            matEndDate formControlName="end" placeholder="End date" />
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker color="accent" #picker></mat-date-range-picker>
                                </mat-form-field>

                            </ng-container>
                        </ng-container>
                        <button [attr.guide]="'list-btn-28' + '__' + sanitizeUrl(url)" fxFlex
                            [disabled]="searchTerm==undefined && ChartType !== '1'" color="warn"
                            (click)="resetFilters()" mat-flat-button>Reset
                            Filter
                        </button>
                        <button [attr.guide]="'list-btn-29' + '__' + sanitizeUrl(url)" fxFlex
                            [disabled]="searchTermPresent" color="primary" (click)="searchFilter()" mat-flat-button>
                            Search Filter
                        </button>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <ng-content></ng-content>
        </div>
    </div>

    <div class="popup" *ngIf="isPopupOpen" (click)="$event.stopPropagation()">
        <calsoft-filter-list-popup [columns]="columns" [filterSelectObj]="filterSelectObj"
            (filterChangeColumn)="handleFilterApplied($event)" [name]="name" [type]="type"
            (closePopup)="closePopup($event)"></calsoft-filter-list-popup>
    </div>
</div>